import { Component } from '@angular/core';

@Component({
  selector: 'hsc-maintenance-widget',
  template: `
    <div class="w-[415px] border border-solid p-8 px-6">
      <p class="bolt-heading-sm bolt-serif text-vibrant-blue font-bold">Quote</p>
      <p class="bolt-heading-xs">Quoting temporarily unavailable</p>
      <p class="bolt-body-copy-lg mb-0! font-medium">Please try again later.</p>
    </div>
  `,
})
export class MaintenanceWidget {}
